export default {
  data() {
    return {
      formLabelPosition: 'top',
      formSize: 'default'
    }
  },
  methods: {
    onFormWindowResize() {
      this.formLabelPosition = (window.innerWidth >= 768) ? 'right' : 'top'
      this.formSize = (window.innerWidth >= 768) ? 'default' : 'mini'
    }
  },
  mounted() {
    this.onFormWindowResize()
    window.addEventListener('resize', this.onFormWindowResize)
  }
}
